import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ContractClassEffects } from './store/contract-class.effects';
import { StoreModule } from '@ngrx/store';
import * as reducer from './store/contract-class.reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(
            reducer.contractClassesFeatureKey,
            reducer.reducer
        ),
        EffectsModule.forFeature([ContractClassEffects])
    ]
})
export class ClassModule {}
